export { default as NumericKeypad } from './NumericKeypad';
